export const MAX_CONTENT_WIDTH = "80rem";
export const CONTENT_PADDING = "2rem";